var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.12,24.05c3.86,0,7-3.13,7-6.97v-1.83c0-3.84-3.14-6.97-7-6.97s-7,3.13-7,6.97v1.83 C40.12,20.92,43.26,24.05,47.12,24.05z M43.08,15.25c0-2.21,1.81-4.01,4.04-4.01s4.04,1.8,4.04,4.01v1.83 c0,2.21-1.81,4.01-4.04,4.01s-4.04-1.8-4.04-4.01V15.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.12,25.27c-4.27,0-8.03,2.13-10.31,5.37c0.7,0.82,1.32,1.69,1.9,2.6c1.64-2.96,4.77-5,8.41-5 c5.31,0,9.63,4.29,9.63,9.57v8.94h2.96V37.8C59.72,30.89,54.07,25.27,47.12,25.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.72,25.7C9,25.7,0.28,34.38,0.28,45.04v14.57h2.96V45.04c0-9.03,7.39-16.37,16.48-16.37 S36.2,36.01,36.2,45.04v14.44h2.96V45.04C39.16,34.38,30.44,25.7,19.72,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.72,24.05c5.74,0,10.4-4.64,10.4-10.35v-2.96c0-5.71-4.67-10.35-10.4-10.35S9.32,5.03,9.32,10.74v2.96 C9.32,19.4,13.99,24.05,19.72,24.05z M12.29,10.74c0-4.07,3.34-7.39,7.44-7.39s7.44,3.31,7.44,7.39v2.96 c0,4.07-3.34,7.39-7.44,7.39s-7.44-3.31-7.44-7.39V10.74z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 41.18,
    className: "st0",
    width: 8.87,
    height: 2.96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.24,
    y: 35.56,
    className: "st0",
    width: 2.96,
    height: 22.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.12,34.33c-0.85,0-1.6,0.34-2.23,0.82c-0.63-0.48-1.38-0.82-2.23-0.82c-2.05,0-3.71,1.66-3.71,3.7h2.96 c0-0.8,1.5-0.8,1.5,0c0,2.04,1.67,3.7,3.71,3.7v-2.96c-0.41,0-0.75-0.34-0.75-0.73c0-0.8,1.5-0.8,1.5,0h2.96 C55.84,35.99,54.17,34.33,52.12,34.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon_users.984b48c168e33884d7e9b4468e2669a2.svg";
export { ForwardRef as ReactComponent };